import { getAuth } from "firebase/auth";

export async function SingOut() {
  const auth = getAuth()
  await auth.signOut().then(
    localStorage.removeItem('token'),
  ).catch()
}